module.exports = __webpack_public_path__ + "lock-small.9112bf27ba91fa1b99f9b6ef46b26557.svg";